<section class="section white-100" *ngIf="customersData">
  <div class="section-container">
    <h2 class="section-heading mar-b-48">
      {{ customersData.title }}
    </h2>
    <div class="section-helping-businesses-container">
      <div
        class="grey-100 section-helping-businesses"
        *ngFor="let stat of customersData.stats"
      >
        <figure class="display-c">
          <img
            src="{{ stat.fields.imageicon.fields.file.url }}"
            class="ico-48"
            alt="{{ stat.fields.imageicon.fields.title }}"
          />
        </figure>
        <div class="helping-businesses">
          <h3 class="product-blog-heading">{{ stat.fields.title }}</h3>
          <div
            class="efficient-payment-description"
            [innerHtml]="stat.fields.description | toHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</section>
